import $ from 'jquery';
import 'spotlight.js';

/* global Spotlight */

class Lightbox {
  constructor() {
    this.galleries = $('.wp-block-gallery, .gallery');

    if (!this.galleries.length) {
      return;
    }

    this.init();
  }

  init() {
    if (this.galleries.find('a > img')) {
      this.galleries.find('a > img').each((i, el) => {
        const image = $(el);

        image.parent().addClass('spotlight');
      });
      Spotlight.init();
    }
  }
}

export default new Lightbox();



// WEBPACK FOOTER //
// ./src/scripts/modules/lightbox.js